/**
 * This class represents a FormField fetched from the API including all the needed business functions/methods related.
 */
class FormField {
  /** ---------------- Mappers functions ---------------- */
  static fromAPI = (data) => ({
    checkFieldName: data.check_field_name,
    choices: data.choices?.map((choice) => ({
      label: choice.label,
      value: choice.value,
    })),
    defaultValue: data.default_value,
    helpText: data.help_text,
    id: data.id,
    isDisabled: false,
    isReadOnly: data.is_read_only,
    isRequired: data.is_required,
    isWriteOnly: data.is_write_only,
    label: data.label,
    name: data.name,
    placeholder: data.placeholder,
    type: data.type,
    validations: FormField.mapValidationsFromAPI(data?.validations),
  });

  static fromAPIOld = (data) => ({
    checkFieldName: data.check,
    choices: data.choices?.map((choice) => ({
      label: choice.label,
      value: choice.value,
    })),
    defaultValue: data.default_value,
    helpText: data.help_text,
    id: data.id,
    isDisabled: false,
    isReadOnly: data.read_only,
    isRequired: data.required,
    isWriteOnly: data.write_only,
    label: data.label,
    name: data.name,
    placeholder: data.placeholder,
    type: data.type,
    validations: {
      ...FormField.mapValidationsFromAPI(data?.validations),
      minLength: data.min_length,
    },
  });

  /**
   * Map a menu config returned by the API.
   */
  static mapValidationsFromAPI = (validations) => ({
    address: validations?.address ? {
      allowedCities: validations?.address?.allowed_cities,
      allowedCountryCodes: validations?.address?.allowed_country_codes,
      allowedRegionCodes: validations?.address?.allowed_region_codes,
      allowedZipCodes: validations?.address?.allowed_zip_codes,
    } : null,
    allowedDates: null, // Empty array means no date allowed
    max: validations?.max,
    maxDate: validations?.max_date,
    maxLength: validations?.max_length,
    min: validations?.min,
    minDate: validations?.min_date,
    minLength: validations?.min_length,
    regexp: validations?.regexp,
    step: validations?.step,
  });

  /** ---------------- Business functions ---------------- */
}

export default FormField;
